import { render, staticRenderFns } from "./preorder-info.vue?vue&type=template&id=97ebbe40&"
import script from "./preorder-info.vue?vue&type=script&lang=js&"
export * from "./preorder-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports